import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop"]

  open() {
    this.backdropTarget.classList.add("unfollow-modal__backdrop--open")
  }

  close(event) {
    if (event.target === this.backdropTarget || event.currentTarget !== this.backdropTarget) {
      this.backdropTarget.classList.remove("unfollow-modal__backdrop--open")
    }
  }

  backdropClick(event) {
    if (event.target === this.backdropTarget) {
      this.backdropTarget.classList.remove("unfollow-modal__backdrop--open")
    }
  }
}
